<template>
  <div
    v-draggable="{
      meta: {
        ...targetList,
        _type: 'source'
      }
    }"
    :draggable="canDrag"
    id="my-documents-drag"
    class="my-documents-content"
  >
    <div id="my-documents-content-box" class="my-documents-content-box">
      <template v-if="fileType === 'list'">
        <source-table
          @onSelectChange="(value) => onSelectChange(value)"
          @clickFile="(value) => clickFile(value)"
          @dblclickFlor="(value) => dblclickFlor(value)"
          @dblclickFile="(value) => dblclickFile(value)"
          :scrollY="scrollY"
          :columns="columns"
          :dataSource="dataSource"
          :selectedRowKeys="selectedRowKeys"
        ></source-table>
      </template>
      <div class="my-documents-content-box-file" v-else>
        <template v-for="(item, index) in dataSource">
          <file
            :key="index"
            :file="item"
            :selectedRowKeys="selectedRowKeys"
            @check="(value) => check(value)"
            @clickFile="(value) => clickFile(value)"
            @dblclickFlor="(value) => dblclickFlor(value)"
            @dblclickFile="(value) => dblclickFile(value)"
          ></file>
        </template>
      </div>
    </div>
    <div id="coverup">
      <div class="coverup-aaac">
        <a-icon type="copy" style="font-size: 80px" />
        <div class="coverup-length">
          <div class="coverup-length-span">
            {{ selectedRowKeys.length }}
          </div>
        </div>
      </div>
    </div>
    <preview-modal
      :visible="previewVisible"
      :data="previewData"
      @close="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
import PreviewModal from '../../../components/PreviewModal.vue'
import SourceTable from '../FileList/SourceTable.vue'
import File from '../FileList/File.vue'
import { FolderServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'
const fsp = new FolderServiceProxy()

export default {
  components: {
    SourceTable,
    PreviewModal,
    File
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('page_my_document_filenm'),
          dataIndex: 'name',
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('page_my_document_path'),
          dataIndex: 'allPathName',
          ellipsis: true
        },
        {
          title: this.$t('page_my_document_edition'),
          dataIndex: 'vision',
          ellipsis: true,
          width: 88
        },
        {
          title: this.$t('page_my_document_size'),
          dataIndex: 'contentLength',
          width: 88,
          ellipsis: true,
          scopedSlots: { customRender: 'contentLength' }
        },
        {
          title: this.$t('page_my_document_type'),
          dataIndex: 'suffix',
          ellipsis: true,
          width: 88
        },
        {
          title: this.$t('page_plan_create_time'),
          dataIndex: 'updateTime',
          ellipsis: true,
          width: 170,
          scopedSlots: { customRender: 'updateTime' }
        }
      ],
      dataSource: [],
      catchData: [],
      selectedRowKeys: [],
      targetList: [],
      scrollY: 0,
      previewVisible: false,
      previewData: {}
      // canDrag: true
    }
  },
  props: {
    fileType: {
      type: String,
      default: 'file'
    },
    selectedKey: {
      // 选择树节点
      type: String,
      default: ''
    },
    keyWords: {
      type: String,
      default: ''
    }
  },
  computed: {
    canDrag() {
      return this.targetList && this.targetList.length > 0
    }
  },
  watch: {
    selectedKey: {
      handler() {
        if (this.selectedKey.length) this.getData()
      },
      immediate: true,
      deep: true
    },
    selectedRowKeys: {
      handler() {
        if (this.selectedRowKeys.length) {
          const targetList = this.dataSource.filter(
            (res) => this.selectedRowKeys.indexOf(res.id) != -1
          )
          this.targetList = targetList
          this.$emit('doTransmission', targetList)
        } else {
          this.targetList = []
          this.$emit('doTransmission', [])
        }
      },
      immediate: true,
      deep: true
    },
    keyWords: {
      handler() {
        if (this.keyWords.length) {
          if (this.catchData && this.catchData.length) {
            this.dataSource = this.catchData.filter((res) => res.name.indexOf(this.keyWords) !== -1)
          }
        } else {
          if (this.catchData && this.catchData.length) {
            this.dataSource = this.catchData
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    const test = document.getElementById('my-documents-drag')
    test.addEventListener(
      'dragstart',
      (e) => {
        // e.preventDefault()
        var dt = e.dataTransfer
        if (dt && this.targetList.length > 0) {
          const item = document.getElementById('coverup')
          var crt = item.cloneNode(true)
          crt.className = 'aa-extra-box'
          crt.id = 'aa-extra'
          document.body.appendChild(crt)
          e.dataTransfer.setDragImage(crt, 0, 0)
          e.dataTransfer.setData('Text', JSON.stringify(this.targetList))
        }
      },
      false
    )
    test.addEventListener(
      'dragend',
      (e) => {
        const div = document.getElementById('aa-extra')
        if (div) {
          document.body.removeChild(div)
        }
      },
      false
    )
  },
  methods: {
    check(file) {
      if (this.selectedRowKeys.indexOf(file.id) === -1) {
        this.selectedRowKeys.push(file.id)
      } else {
        const rowKeys = this.selectedRowKeys
        this.selectedRowKeys = rowKeys.filter((res) => res.indexOf(file.id) === -1)
      }
    },
    clickFile(file) {
      this.selectedRowKeys = [file.id]
    },
    dblclickFlor(file) {
      this.$emit('dblclickFlor', file)
    },
    dblclickFile(file) {
      this.previewVisible = true
      this.previewData = file
    },
    closePreview() {
      this.previewVisible = false
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    async getData() {
      this.dataSource = []
      this.loading = true
      const data = await fsp.folderList(this.selectedKey, '')
      const folderList = data.folderList.map((res) => {
        res.isfolder = true
        return res
      })
      const fileList = data.fileList.map((res) => {
        res.isfolder = false
        return res
      })
      this.dataSource = [...folderList, ...fileList]
      this.catchData = this.dataSource
      this.getScroll(this.dataSource)
      this.loading = false
    },
    getScroll(dataSource) {
      const documentDiv = document.getElementById('my-documents-content-box')
      if (documentDiv) {
        const pheight = dataSource.length * 33
        if (pheight > documentDiv.clientHeight - 48) {
          this.scrollY = documentDiv.clientHeight - 50
        } else {
          this.scrollY = 0
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.my-documents-content {
  margin-top: 8px;
  height: calc(100% - 40px);
  width: 100%;
  &-box {
    background-color: #f8f8f8;
    border-radius: 2px;
    border: solid 1px #d8d8d8;
    height: 100%;
    &-file {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding: 8px 4px;
      height: 100%;
      overflow-y: auto;
      align-items: flex-start;
      align-content: flex-start;
    }
  }
}
#coverup {
  background-color: #ffffff;
  width: 105px;
  height: 105px;
  position: absolute;
  top: -2500px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.coverup-aaac {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.coverup-length {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
  z-index: 8;
  &-span {
    background-color: rgba(74, 144, 226, 0.85);
    color: #ffffff;
    height: 35px;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.aa-extra-box {
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  width: 105px;
  height: 105px;
  position: absolute;
  top: -2500px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
